import React from 'react';
import SEO from '../components/SEO';
import structuredData from '../data/structuredData.json';
import heroImage from '../images/hero-section-bg-image.svg';
import googleicon from '../images/3m-logo.png';
import amazonicon from '../images/c-pak-logo.png';
import canonicalicon from '../images/safran-landing-system-icon.png';
import sdk from '../images/sdk-development-icon.svg';
import maintenance from '../images/sdk-maintenance-icon.svg';
import crossplatform from '../images/cross-platform-development.svg';
import partnerbg from '../images/partner-bg.avif';
import storiesbg from '../images/success-stories-bg.svg';
import xcardbg from '../images/stay-informed-card-bg.svg';
import stay from '../images/bg-image-card.svg';
import discord from '../images/discord-card-bg.svg';
import gitcard from '../images/git-card-bg.svg';
import HomeCardSlider from '../components/HomeCardSlider'
import Insights from '../components/Insights'
import GlbSection from '../components/GlbSection'
import ScrollFadeIn from '../components/ScrollFadeIn'
import { IconBrandInstagram } from '@tabler/icons-react';
import { IconBrandFacebook } from '@tabler/icons-react';
import { IconChevronRight } from '@tabler/icons-react';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import { IconBrandLinkedin } from '@tabler/icons-react';
import Header from '../components/Header';
import precisionimg from '../images/built-for-precision.png';
import industrycertified from '../images/industry-certified-quality.png';
import integratedimg from '../images/integrated-engineering.webp';
import jigs from '../images/jigs-fixtures-design.svg';

const services = [
    {
        title: "Precision Tooling & Machining",
        icon: sdk,
        alt: "SDK Development Icon",
        description:
            "High-accuracy parts for semiconductor, aerospace, and advanced packaging applications. ",
    },
    {
        title: "Industrial Automation",
        icon: maintenance,
        alt: "SDK Maintenance Icon",
        description:
            "Custom-built automation systems to streamline your operations and boost output.",
    },
    {
        title: "Jigs & Fixtures Design",
        icon: jigs,
        alt: "Cross Platform Development Icon",
        description:
            "Tailored engineering tools to improve manufacturing consistency and reduce setup time.",
    },
    {
        title: "Reverse Engineering & Prototyping",
        icon: crossplatform,
        alt: "Cross Platform Development Icon",
        description:
            "From legacy parts to cutting-edge prototypes—built fast, built right. ",
    },
];
const Home = () => {
    return (
        <>
            <SEO
                title="GXL Engineering - Precision Engineering Malaysia | CNC Machining & Automation"
                description="Precision engineering solutions in Malaysia offering CNC machining, tooling, automation, and high-accuracy manufacturing for industrial needs"
                url="/"
                type="website"
                noSuffix
                structuredData={structuredData.home}
            />
            <section
                style={{
                    backgroundImage: `url(${heroImage})`,
                    backgroundPosition: '50% 0',
                }}
                className="bg-no-repeat bg-cover max-w-none relative home-hero">
                <Header />
                <div className="container lg:px-10   px-6 max-w-[1600px] mx-auto lg:py-16 py-10">
                    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-0 gap-4">
                        <ScrollFadeIn delay={0.1}>
                            <div className='lg:space-y-10 space-y-6'>
                                <div className='space-y-2'>
                                    <h1 className=' lg:text-[52px] md:text-5xl leading-normal text-4xl md:leading-[62px] font-semibold lg:leading-[67px] bg-[radial-gradient(89.47%_51.04%_at_44.27%_50%,_#E2E3E9_0%,_#D4D6DE_52.73%,_#3D3F4C_100%)] bg-clip-text text-transparent '>Engineering Tomorrow’s Possibilities. Today.</h1>
                                    <p className='text-[rgb(171,174,187)] lg:text-lg text-base font-medium'>Empowering innovation in precision tooling, automation, and industrial solutions for global manufacturers. </p>
                                </div>
                                <div className='space-y-4'>
                                    <p className='text-[rgb(171,174,187)] lg:text-base text-sm font-medium'>Trusted by industry leaders</p>
                                    <div className='flex items-center sm:gap-6 gap-4 hero-icon'>
                                        <img src={googleicon} alt="Google Icon" className="h-11 w-auto" />
                                        <img src={amazonicon} alt="Amazon Icon" className="h-11 w-auto" />
                                        <img src={canonicalicon} alt="Canonical Icon" className="h-11 w-auto" />
                                    </div>
                                </div>
                                <div className='sm:flex gap-6 sm:space-y-0 space-y-5'>
                                    <a
                                        href="/contact"
                                        className="transition-colors duration-300 group inline-flex items-center outline-none justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-10 text-[15px] px-6 rounded-full md:h-10 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.74)] font-semibold relative"
                                    >
                                        <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#fcc171_0%,#C17C56_50%,#362821_100%)]"></span>
                                        <span className="absolute -top-[5px] bottom-0.5 left-1/2 w-[91%] -translate-x-1/2 bg-btn-glowing mix-blend-screen blur-[1px] transition-transform duration-300 ease-in-out group-hover:translate-y-[-2px]"></span>
                                        <span className="absolute inset-0 rounded-full bg-black"></span>
                                        <span className="absolute inset-0 rounded-full bg-btn-glowing-inset opacity-100 transition-opacity duration-300 ease-in-out group-hover:opacity-0"></span>
                                        <span className="absolute inset-0 rounded-full bg-btn-glowing-inset-hover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"></span>
                                        <span className="relative z-20 bg-[linear-gradient(180deg,#FFF_33.33%,#E4D0B1_116.67%)] bg-clip-text text-transparent">
                                            Discover Our Expertise
                                        </span>
                                    </a>
                                    <a href="/contact" className="group text-base font-medium text-white flex gap-1 items-center hover:text-[#fcc171] transition-colors duration-200">
                                        Let's Build Together
                                        <IconChevronRight
                                            size={20}
                                            stroke={2}
                                            className="chevron-icon group-hover:translate-x-1 transition-transform duration-300"
                                        />
                                    </a>
                                </div>
                            </div>
                        </ScrollFadeIn>
                        <div>
                            <GlbSection />
                        </div>
                    </div>
                </div>
                <div className='container lg:py-16 py-10 lg:px-10 px-6 max-w-[1600px] mx-auto'>
                    <ScrollFadeIn delay={0.2}>
                        <div className='space-y-2'>
                            <h2 className='text-white lg:text-5xl text-3xl font-semibold'>Our Core Services </h2>
                            <p className='text-[rgb(171,174,187)] lg:text-lg text-base font-normal lg:w-[60%]'>We provide end-to-end precision engineering solutions designed to meet the demands of high-performance industries.</p>
                        </div>

                        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-6 lg:mt-10 mt-6">
                            {services.map(({ title, icon, alt, description }) => (
                                <div key={title} className="space-y-4">
                                    <div className="space-y-2">
                                        <img src={icon} alt={alt} className="h-6 w-auto" loading="lazy" />
                                        <h3 className="text-white lg:text-xl text-lg font-semibold flex gap-4">
                                            {title}
                                        </h3>
                                        <p className="text-[rgb(171,174,187)] lg:text-base text-sm font-normal">{description}</p>
                                    </div>
                                    <button className="group text-base font-semibold text-white flex gap-1 items-center" aria-label={`Learn more about ${title}`}>
                                        Learn more
                                        <IconChevronRight className="chevron-icon group-hover:translate-x-1 transition-transform duration-300" size={20} stroke={2} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </ScrollFadeIn>
                </div>
            </section>
            <section className='bg-[#E5E5E6] lg:py-16 py-10'>
                <div className='max-w-[1600px] mx-auto'>
                    <ScrollFadeIn>
                        <div className='space-y-3 container-md'>
                            <div className='space-y-2'>
                                <h2 className='text-gray-800 lg:text-5xl text-3xl  max-w-[544px] font-bold  2xs:max-w-72'>Empowering Innovation Through Precision Engineering </h2>
                                <p className='text-gray-800 max-w-[688px] lg:text-lg text-base font-medium'>Our commitment to precision, reliability, and customer-centric innovation drives engineering solutions trusted across Malaysia and beyond. From high-performance molds to custom jigs, we deliver excellence in every detail—empowering manufacturers and developers to push boundaries. </p>
                            </div>
                            <a href="/solutions" className="group text-lg font-semibold text-[rgb(230,145,53)] hover:text-[#A86525] flex gap-1 items-center transition-colors duration-200 tracking-tight cursor-pointer">Explore our product innovations <IconChevronRight className="chevron-icon group-hover:translate-x-1 transition-transform duration-300" size={20} stroke={2} /></a>
                        </div>
                    </ScrollFadeIn>
                    <ScrollFadeIn delay={0.2}>
                        <HomeCardSlider />
                    </ScrollFadeIn>
                    <ScrollFadeIn delay={0.3}>
                        <div className="container-md mt-12 lg:mt-10  md:mt-7 sm:mt-6">
                            <ul className="grid md:grid-cols-4 grid-cols-2 gap-4 ">
                                <li className="flex max-w-44 flex-col lg:max-w-48 max-w-32">
                                    <span className="text-3xl font-semibold leading-dense tracking-tighter text-gray-800">
                                        15 Years
                                    </span>
                                    <p className="mt-2 text-base leading-snug tracking-tight text-gray-600">
                                        Industry experience
                                    </p>
                                </li>
                                <li className="flex max-w-44 flex-col lg:max-w-48">
                                    <span className="text-3xl font-semibold leading-dense tracking-tighter text-gray-800">
                                        9001
                                    </span>
                                    <p className="mt-2 text-base leading-snug tracking-tight text-gray-600">
                                        ISO Certified quality management
                                    </p>
                                </li>
                                <li className="flex max-w-44 flex-col lg:max-w-48 max-w-32">
                                    <span className="text-3xl font-semibold leading-dense tracking-tighter text-gray-800">
                                        200+
                                    </span>
                                    <p className="mt-2 text-base leading-snug tracking-tight text-gray-600">
                                        Projects delivered successfully
                                    </p>
                                </li>
                                <li className="flex max-w-44 flex-col lg:max-w-48">
                                    <span className="text-3xl font-semibold leading-dense tracking-tighter text-gray-800">
                                        10+
                                    </span>
                                    <p className="mt-2 text-base leading-snug tracking-tight text-gray-600">
                                        Serving electronics, semiconductors, and automation industries.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </ScrollFadeIn>
                </div>
            </section>
            <section className='bg-[#E5E5E6] lg:py-16 py-10'>
                <div className='container lg:px-10 px-6 max-w-[1024px] mx-auto'>
                    <ScrollFadeIn>
                        <div>
                            <h2 className='text-gray-800 text-center lg:text-5xl text-3xl font-bold'>
                                Why GXL Engineering
                            </h2>
                        </div>
                    </ScrollFadeIn>
                    <ScrollFadeIn delay={0.1}>
                        <div className='grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-6'>
                            <div
                                style={{ backgroundImage: `url(${partnerbg})` }}
                                className='px-5 py-5 rounded-2xl h-[328px] bg-cover flex justify-center group transition-all duration-300 cursor-pointer items-center'
                            >
                                <div>
                                    <h3 className='text-center lg:text-3xl text-2xl font-semibold leading-normal bg-[radial-gradient(89.47%_51.04%_at_44.27%_50%,_#E2E3E9_0%,_#D4D6DE_52.73%,_#3D3F4C_100%)] bg-clip-text text-transparent'>
                                        Trusted by Global Brands
                                    </h3>
                                    <p className='text-white font-normal text-center'>
                                        Proud partner of 3M, Nexperia, Safran, and more
                                    </p>
                                </div>
                            </div>
                            <div
                                style={{ backgroundImage: `url(${precisionimg})` }}
                                className='px-5 py-8 rounded-2xl h-[328px] bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer lg:col-span-2'
                            >
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                        Built for Precision
                                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                            <IconChevronRight size={20} stroke={2} />
                                        </span>
                                    </h3>
                                    <p className='text-white font-normal'>
                                        Tolerance up to ±0.005mm for the most complex demands.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ScrollFadeIn>
                    <ScrollFadeIn delay={0.2}>
                        <div className='grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-6'>
                            <div
                                style={{ backgroundImage: `url(${industrycertified})` }}
                                className='px-5 py-8 rounded-2xl h-[328px] bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer lg:col-span-2'
                            >
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                        Industry-Certified Quality
                                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                            <IconChevronRight size={20} stroke={2} />
                                        </span>
                                    </h3>
                                    <p className='text-white font-normal'>
                                        ISO-compliant, QA-driven, and performance-tested.
                                    </p>
                                </div>
                            </div>
                            <div
                                style={{ backgroundImage: `url(${integratedimg})` }}
                                className='px-5 py-8 rounded-2xl h-[328px] bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer'
                            >
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                        Integrated Engineering Support
                                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                            <IconChevronRight size={20} stroke={2} />
                                        </span>
                                    </h3>
                                    <p className='text-white font-normal'>
                                        Our team works alongside yours from idea to implementation
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ScrollFadeIn>
                </div>
            </section>

            <section
                style={{ backgroundImage: `url(${storiesbg})` }}
                className="lg:bg-center bg-no-repeat bg-cover lg:py-16 py-10 bg-left">
                <div className='container lg:px-10 px-6 max-w-[1600px] mx-auto'>
                    <div className='space-y-8'>
                        <ScrollFadeIn delay={0.2}>
                            <div className='space-y-2'>
                                <h2 className='text-white text-center lg:text-4xl text-3xl font-medium '>Join our growing team</h2>
                                <p className='text-[rgb(171,174,187)] text-center text-base font-medium lg:w-[40%] mx-auto'>Obsessed with developer experience? So are we. Come shape the future with us.</p>
                            </div>
                        </ScrollFadeIn>
                        <ScrollFadeIn delay={0.3}>
                            <div className='flex justify-center'>
                                <a
                                    href="/contact"
                                    className="transition-colors duration-300 group inline-flex items-center outline-none justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-10 text-[15px] px-6 rounded-full md:h-10 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.74)] font-semibold relative"
                                >
                                    <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#fcc171_0%,#C17C56_50%,#362821_100%)]"></span>
                                    <span className="absolute -top-[5px] bottom-0.5 left-1/2 w-[91%] -translate-x-1/2 bg-btn-glowing mix-blend-screen blur-[1px] transition-transform duration-300 ease-in-out group-hover:translate-y-[-2px]"></span>
                                    <span className="absolute inset-0 rounded-full bg-black"></span>
                                    <span className="absolute inset-0 rounded-full bg-btn-glowing-inset opacity-100 transition-opacity duration-300 ease-in-out group-hover:opacity-0"></span>
                                    <span className="absolute inset-0 rounded-full bg-btn-glowing-inset-hover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"></span>
                                    <span className="relative z-20 bg-[linear-gradient(180deg,#FFF_33.33%,#E4D0B1_116.67%)] bg-clip-text text-transparent">
                                        Book a consultation
                                    </span>
                                </a>
                            </div>
                        </ScrollFadeIn>
                    </div>
                </div>
            </section>
            <section className='bg-[#E5E5E6] lg:py-16 py-10'>
                <div className='max-w-[1600px] mx-auto'>
                    <ScrollFadeIn delay={0.1}>
                        <div className='space-y-3 container-md'>
                            <div className='space-y-2'>
                                <h2 className='text-gray-800 lg:text-5xl text-3xl max-w-[844px] font-bold 2xs:max-w-72'>
                                    Access 30+ Years of Precision Engineering Expertise and Resources
                                </h2>
                                <p className='text-gray-800 max-w-[688px] lg:text-lg text-base font-medium'>
                                    Stay informed and inspired by our decades of hands-on experience in high-precision engineering. Discover insights, technical expertise, and solutions designed to help you build smarter, faster, and with greater accuracy.
                                </p>
                            </div>
                            <a
                                href="/blog"
                                className="group text-lg font-semibold text-[rgb(230,145,53)] hover:text-[#A86525] flex gap-1 items-center transition-colors duration-200 tracking-tight cursor-pointer"
                            >
                                Explore Our Engineering Know-How
                                <IconChevronRight
                                    className="chevron-icon group-hover:translate-x-1 transition-transform duration-300"
                                    size={20}
                                    stroke={2}
                                />
                            </a>
                        </div>
                    </ScrollFadeIn>
                    <ScrollFadeIn delay={0.3}>
                        <Insights />
                    </ScrollFadeIn>
                </div>
            </section>
            <section className='bg-[#E5E5E6] lg:py-16 py-10'>
                <div className='container lg:px-10 px-6 max-w-[1600px] mx-auto'>
                    <div className='space-y-3'>
                        <ScrollFadeIn delay={0.2}>
                            <div className='space-y-2'>
                                <h2 className='text-gray-800 lg:text-5xl text-3xl text-center font-bold '>Join the GXL Engineering Community </h2>
                                <p className='text-gray-800 text-center lg:text-lg text-base font-medium'>Engage with developers, share insights, and stay up-to-date.</p>
                            </div>
                        </ScrollFadeIn>
                    </div>
                    <ScrollFadeIn delay={0.3}>
                        <div className='grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-6'>
                            <div
                                className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-[2.25rem] rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'>
                                <img
                                    alt=""
                                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                    loading="lazy"
                                    decoding="async"
                                    data-nimg="1"
                                    src={xcardbg}
                                    style={{ color: 'transparent' }}
                                />
                                <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5 flex justify-center items-center ">
                                    <IconBrandInstagram className='text-[#fff]/70' size={32} stroke={1.5} />
                                </div>
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Instagram </h3>
                                    <p className='text-[rgb(171,174,187)] font-normal'>Follow us for updates, stories, and highlights.</p>
                                </div>
                                <div className=''>
                                    <h3 className='text-white text-base font-medium leading-[inherit]'>   <a href="http://instagram.com/gxl_engineering" className=' flex items-center' target="_blank" rel="noopener noreferrer">
                                        Follow us <span
                                            className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out"
                                        >
                                            <IconChevronRight className="" size={20} stroke={2} />
                                        </span></a></h3>
                                </div>
                            </div>
                            <div
                                className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-[2.25rem] rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer' >
                                <img
                                    alt=""
                                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                    loading="lazy"
                                    decoding="async"
                                    data-nimg="1"
                                    src={stay}
                                    style={{ color: 'transparent' }}
                                />
                                <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5 flex justify-center items-center ">
                                    <IconBrandFacebook className='text-[#fff]/70' size={32} stroke={1.5} />
                                </div>
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Facebook </h3>
                                    <p className='text-[rgb(171,174,187)] font-normal'>Join our community for news and tips.</p>
                                </div>
                                <div className=''>
                                    <h3 className='text-white text-base font-medium leading-[inherit]'>   <a href="https://www.facebook.com/profile.php?id=61555381422813" className=' flex items-center' target="_blank" rel="noopener noreferrer">
                                        Follow us <span
                                            className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                            <IconChevronRight className="" size={20} stroke={2} />
                                        </span></a></h3>
                                </div>
                            </div>
                            <div
                                className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-[2.25rem] rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'>
                                <img
                                    alt=""
                                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                    loading="lazy"
                                    decoding="async"
                                    data-nimg="1"
                                    src={discord}
                                    style={{ color: 'transparent' }}
                                />
                                <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5  flex justify-center items-center ">
                                    <IconBrandWhatsapp className='text-[#fff]/70' size={32} stroke={1.5} />
                                </div>
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Whatsapp</h3>
                                    <p className='text-[rgb(171,174,187)] font-normal'>Get instant updates and alerts. Join us.</p>
                                </div>
                                <div className=''>
                                    <h3 className='text-white text-base font-medium leading-[inherit]'>   <a href="https://api.whatsapp.com/send/?phone=60126815982&text&type=phone_number&app_absent=0" className=' flex items-center' target="_blank" rel="noopener noreferrer">Join us <span
                                        className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                        <IconChevronRight className="" size={20} stroke={2} />
                                    </span></a></h3>
                                </div>
                            </div>
                            <div
                                className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-[2.25rem] rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'>
                                <img
                                    alt=""
                                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                    loading="lazy"
                                    decoding="async"
                                    data-nimg="1"
                                    src={gitcard}
                                    style={{ color: 'transparent' }}
                                />
                                <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5 flex justify-center items-center ">
                                    <IconBrandLinkedin className='text-[#fff]/70' size={32} stroke={1.5} />
                                </div>
                                <div>
                                    <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Linkedin</h3>
                                    <p className='text-[rgb(171,174,187)] font-normal'>Follow for insights, updates, and careers.</p>
                                </div>
                                <div className=''>
                                    <h3 className='text-white text-base font-medium leading-[inherit]'>   <a href="https://www.linkedin.com/company/gxl-engineering" className=' flex items-center' target="_blank" rel="noopener noreferrer">Join us <span
                                        className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out" >
                                        <IconChevronRight className="" size={20} stroke={2} />
                                    </span></a></h3>
                                </div>
                            </div>
                        </div>
                    </ScrollFadeIn>
                </div>
            </section>
        </>
    );
};

export default Home;
